import { Card, CardHeader, CardTitle, CardContent, StatusGroup, Button } from '@sareto/ui';

export function DashboardPage() {
  // Mock data - will be replaced with real API calls
  const revenueRecovered = 12450;
  const totalConversions = 342;
  const recoveredConversions = 156;
  
  return (
    <div className="space-y-8">
      <div>
        <h2 className="text-2xl font-bold text-gray-900">Dashboard</h2>
        <p className="text-gray-600 mt-1">
          Track your recovered revenue and system health
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>System Status</CardTitle>
        </CardHeader>
        <CardContent>
          <StatusGroup
            items={[
              { label: 'Pixel Status', status: 'active' },
              { label: 'CAPI Connection', status: 'healthy' },
              { label: 'License', status: 'valid' },
            ]}
          />
        </CardContent>
      </Card>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <Card variant="elevated">
          <CardContent>
            <div className="text-center py-4">
              <p className="text-sm font-medium text-gray-500 uppercase tracking-wide">
                Revenue Recovered
              </p>
              <p className="text-4xl font-bold text-primary-600 mt-2">
                ${revenueRecovered.toLocaleString()}
              </p>
              <p className="text-sm text-gray-500 mt-1">This month</p>
            </div>
          </CardContent>
        </Card>

        <Card variant="elevated">
          <CardContent>
            <div className="text-center py-4">
              <p className="text-sm font-medium text-gray-500 uppercase tracking-wide">
                Total Conversions
              </p>
              <p className="text-4xl font-bold text-gray-900 mt-2">
                {totalConversions}
              </p>
              <p className="text-sm text-gray-500 mt-1">Tracked this month</p>
            </div>
          </CardContent>
        </Card>

        <Card variant="elevated">
          <CardContent>
            <div className="text-center py-4">
              <p className="text-sm font-medium text-gray-500 uppercase tracking-wide">
                Recovered Conversions
              </p>
              <p className="text-4xl font-bold text-green-600 mt-2">
                {recoveredConversions}
              </p>
              <p className="text-sm text-gray-500 mt-1">
                {((recoveredConversions / totalConversions) * 100).toFixed(1)}% of total
              </p>
            </div>
          </CardContent>
        </Card>
      </div>

      <Card>
        <CardContent>
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0">
              <div className="w-10 h-10 bg-primary-100 rounded-full flex items-center justify-center">
                <svg
                  className="w-5 h-5 text-primary-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>
            </div>
            <div>
              <h3 className="font-semibold text-gray-900">How Revenue Recovered is calculated</h3>
              <p className="text-gray-600 mt-1">
                Revenue Recovered represents conversions that were captured by Sareto's server-side
                tracking but were not reported by Meta's standard pixel due to iOS blocks, 
                AdBlockers, or privacy restrictions. This is the additional value you're recovering 
                with Sareto.
              </p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

